import { Card } from "@/components/ui/card/Card";
import { CONFIDENCE_CARDS } from "./constants";
import type { ConfidenceVariant } from "./types";

const badgeContainerStyles: Record<ConfidenceVariant, string> = {
  high: "bg-[#E8F8F0] text-[#107C41]",
  medium: "bg-[#FEF3C7] text-[#D97706]",
  low: "bg-[#FEE2E2] text-[#DC2626]",
};

const badgeDotStyles: Record<ConfidenceVariant, string> = {
  high: "bg-[#107C41]",
  medium: "bg-[#D97706]",
  low: "bg-[#DC2626]",
};

export function ConfidenceInsight() {
  return (
    <section id="confidence-insight" className="w-full   bg-section">
      <div className="max-w-7xl mx-auto w-full px-6 sm:px-10 lg:px-16 py-20 sm:py-28 flex flex-col gap-12 sm:gap-16 scroll-mt-24">
        {/* Heading Block */}
        <div className="flex flex-col gap-3.5 text-center lg:text-left">
          <h2 className="text-3xl sm:text-5xl font-normal text-text-primary tracking-tight leading-tight">
            Confidence is shown, not hidden.
          </h2>
          <p className="text-base sm:text-lg text-text-secondary leading-relaxed max-w-3xl">
            Repayas shows how reliable your Safe-to-Spend figure is, using
            connected cash data, recent VAT information, or lower-confidence
            assumptions. When the data is not strong enough, it tells you
            clearly.
          </p>
        </div>
        {/* Grid Block */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {CONFIDENCE_CARDS.map((card) => (
            <Card
              key={card.label}
              as="article"
              hoverable
              className="p-8  flex flex-col items-start gap-6 w-full select-none"
            >
              {/* Pill Badge */}
              <div
                className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[13px] font-semibold ${
                  badgeContainerStyles[card.variant]
                }`}
              >
                <span
                  className={`w-1.5 h-1.5 rounded-full shrink-0 ${
                    badgeDotStyles[card.variant]
                  }`}
                  aria-hidden="true"
                />
                {card.label}
              </div>

              {/* Description */}
              <p className="text-sm sm:text-base text-text-secondary leading-relaxed font-normal">
                {card.description}
              </p>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ConfidenceInsight;
